/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyJobRewrite } from '../models/CompanyJobRewrite';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyJobService {

    /**
     * Get company job dictionary
     * @returns string Success
     * @throws ApiError
     */
    public static getCompanyJobDictionary({
        fieldName,
    }: {
        /**
         * Dictionary Field
         */
        fieldName: string,
    }): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobdata/dictionary/{fieldName}',
            path: {
                'fieldName': fieldName,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Deactivate companyJobs
     * @returns any Success
     * @throws ApiError
     */
    public static deactivateCompanyJobs({
        requestBody,
    }: {
        requestBody: {
            companyJobIds: Array<number>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobdata/deactivate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete companyJobs
     * @returns any Success
     * @throws ApiError
     */
    public static deleteCompanyJobs({
        requestBody,
    }: {
        requestBody: {
            companyJobIds: Array<number>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobdata/delete',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export companyJobs
     * @returns string Success
     * @throws ApiError
     */
    public static exportCompanyJobs(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobdata/export',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Bulk Delete Company Job Rewrites
     * @returns any Success
     * @throws ApiError
     */
    public static bulkDeleteCompanyJobRewrites({
        requestBody,
    }: {
        requestBody: {
            rewriteIds: Array<number>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/jobdata/rewrite',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the list of company jobs rewrites
     * @returns CompanyJobRewrite Success
     * @throws ApiError
     */
    public static getCompanyJobRewrites({
        requestBody,
    }: {
        requestBody?: {
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            grade?: Array<string>;
            jobCategory?: Array<number>;
            search?: Array<string>;
            limit?: number;
            offset?: number;
            sort?: Record<string, any>;
        },
    }): CancelablePromise<Array<CompanyJobRewrite>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobdata/rewrite',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export companyJobRewrites
     * @returns string Success
     * @throws ApiError
     */
    public static exportCompanyJobRewrites(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobdata/rewrite/export',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * slot companyJob
     * @returns any Success
     * @throws ApiError
     */
    public static slotCompanyJob({
        companyJobId,
        requestBody,
    }: {
        /**
         * Company Job Id For Slotted
         */
        companyJobId: number,
        requestBody: {
            planId: number;
            values: Record<string, {
                adjustment: number;
                weight?: number;
            }>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobdata/{companyJobId}/slotJobs',
            path: {
                'companyJobId': companyJobId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * copy companyJob
     * @returns any Success
     * @throws ApiError
     */
    public static copyCompanyJob({
        companyJobId,
        requestBody,
    }: {
        /**
         * Company Job Copy From Id
         */
        companyJobId: number,
        requestBody: {
            copyToCompanyJobIds: Array<number>;
            planId: number;
            isRemoveDraftJob?: boolean;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobdata/{companyJobId}/copyJob',
            path: {
                'companyJobId': companyJobId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
